import React, { useContext } from 'react';
import { SaveAsPatchContext, ISaveAsPatchContext } from '../../saveAsPatchModalState/saveAsPatchModalContext';
import { TypeOfChanges } from './components/TypeOfChanges';
import { Info } from './components/Info';
import { RestaurantsMultipleSelect } from './components/RestaurantsMultipleSelect';
import { PropertiesMultipleSelect } from './components/PropertiesMultipleSelect';
import { Cron } from './components/Cron';
import { BtnBlock } from './components/BtnBlock';
import style from './Forms.module.scss';

export const Forms: React.FC = () => {
	const {
		saveData,
		setTypeOfChanges,
		setIDsRestaurant,
		setProperties,
		changeActivationSchedule,
		changeDeactivationSchedule,
		toggleAvailableForRepetition,
		toggleIsHidden,
		changeTypeOfModalWindow,
		initialFormData,
		typeOfChanges,
		IDsSelectedRestaurant,
		selectedProperties,
		activationSchedule,
		deactivationSchedule,
		availableForRepetition,
		isHidden,
	} = useContext<ISaveAsPatchContext>(SaveAsPatchContext);

	return (
		<div className={style.container} data-test="CreateStudioModal">
			<TypeOfChanges setTypeOfChanges={setTypeOfChanges} typeOfChanges={typeOfChanges} />
			{typeOfChanges === 'basedChanges' && (
				<Info
					customerName={initialFormData.customerName}
					categoryName={initialFormData.categoryName}
					fetchedRestaurants={initialFormData.fetchedRestaurants}
					IDSelectedRestaurantOnRestPropsPage={initialFormData.IDSelectedRestaurantOnRestPropsPage}
					activationSchedule={initialFormData.activationSchedule}
					deactivationSchedule={initialFormData.deactivationSchedule}
					availableForRepetition={initialFormData.availableForRepetition}
					isHidden={initialFormData.isHidden}
				/>
			)}
			<RestaurantsMultipleSelect
				setIDsRestaurant={setIDsRestaurant}
				restaurants={initialFormData.fetchedRestaurants}
				IDSelectedRestaurantOnRestPropsPage={initialFormData.IDSelectedRestaurantOnRestPropsPage}
				IDsSelectedRestaurant={IDsSelectedRestaurant}
				typeOfChanges={typeOfChanges}
			/>
			<PropertiesMultipleSelect setProperties={setProperties} selectedProperties={selectedProperties} />
			{typeOfChanges === 'independentChanges' && !!selectedProperties.length && (
				<Cron
					changeActivationSchedule={changeActivationSchedule}
					changeDeactivationSchedule={changeDeactivationSchedule}
					toggleAvailableForRepetition={toggleAvailableForRepetition}
					toggleIsHidden={toggleIsHidden}
					selectedProperties={selectedProperties}
					activationSchedule={activationSchedule}
					deactivationSchedule={deactivationSchedule}
					availableForRepetition={availableForRepetition}
					isHidden={isHidden}
					hasSchedulePriority={initialFormData.hasSchedulePriority}
				/>
			)}
			<BtnBlock
				onClose={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
				onSaveAndMakeOtherChanges={() => saveData('saveAndMakeOtherChanges')}
				onSaveAndClose={() => saveData('saveAndClose')}
				disabledSave={!IDsSelectedRestaurant.length || !selectedProperties.length}
			/>
		</div>
	);
};
